import IBAN from 'fast-iban';

export default (value) => {
  if (value === '') {
    return true;
  }

  try {
    return IBAN.validateIBAN(value);
  } catch (e) {
    return false;
  }
};
